import AppSelectorMixin from './mixins/AppSelectorMixin'

export default {
  name: 'AppSelector',
  mixins: [AppSelectorMixin]
}
